<script>
    import {API_URL} from "../../../env";
    import AccountHeader from "../../components/account/AccountHeader.svelte";
    import AccountNav from "../../components/account/AccountNav.svelte";
    import Loading from "../../placeholders/ContentLoading.svelte";
    import Error from "../../placeholders/Error.svelte";
    import checkLoginValidity from "../../lib/checkLoginValidity";
    import {push, replace} from "svelte-spa-router";
    import {userData} from "../../js/stores";
    import {addAlert} from "../../js/alert";

    window.scrollTo(0, 0);
    if ($userData === null) replace("/?m=prihlasit-sa")

    let data = fetchData()

    async function fetchData() {
        const res = await fetch(API_URL + '/users/addresses', {
            method: 'GET',
            credentials: "include",
        })

        if (checkLoginValidity(res.status)) return await push("/?m=prihlasit-sa");

        return await res.json()
    }

    let isDeleting = false
    async function deleteAddress(id) {
        if (isDeleting || isNaN(parseInt(id))) return;

        let result = confirm("Naozaj chcete adresu odstrániť?")

        if (result) {
            isDeleting = true

            const res = await fetch(API_URL + '/users/addresses/' + id, {
                method: 'DELETE',
                credentials: "include",
            })

            isDeleting = false
            if (!res.ok) {
                if (checkLoginValidity(res.status)) return await push("/?m=prihlasit-sa");
                addAlert("danger", "Chyba", "Adresu sa nepodarilo odstrániť. Skúste to prosím znova.")
            } else {
                Promise.resolve(data).then(dat => {
                    data = dat.filter(v => v.id !== id)
                })
            }
        }
    }
</script>

<section class="container" id="account">

    <AccountHeader/>

    <div class="account">

        <AccountNav/>

        <div class="account-content">
            <h2>MOJE ADRESY <a href="#/ucet/nova-adresa" class="float-right"><i class="fas fa-fw fa-plus"></i>PRIDAŤ NOVÚ ADRESU</a></h2>
            <p>V tomto odkaze nájdete všetky svoje uložené adresy pre rýchlejšie vypĺňanie objednávok. Pokiaľ chcete mať viac adries na výber, pridajte si novú adresu a pri budúcej objednávke budete mať na výber, ktorá sa vám automaticky vyplní.</p>
            <div class="sel-list">
                {#await data}
                    <Loading/>
                {:then data}
                    {#if data?.length > 0}
                        {#each data as row}
                            <div class="sel-item flex-column flex-md-row">
                                <div class="sel-text">
                                    <h4>
                                        {#if row.is_company}
                                            {row.company}
                                        {:else}
                                            {row.name} {row.surname}
                                        {/if}
                                    </h4>
                                    <ul class:company={row.is_company}>
                                        <li><span>{row.street}</span></li>
                                        <li><span>{row.zip}, {row.city}</span></li>
                                        <li><span>{row.phone}</span></li>
                                        {#if row.is_company}
                                            <li>IČO <span>{row.ico || ""}</span></li>
                                            <li>DIČ <span>{row.dic || ""}</span></li>
                                            <li>IČ DPH <span>{row.ic_dph || ""}</span></li>
                                        {/if}
                                    </ul>
                                </div>
                                <div class="sel-buttons mt-4 mt-lg-0">
                                    <a href="#/ucet/detail-adresy/{row.id}" class="btn btn-primary">
                                        <i class="fas fa-fw fa-edit mr-sm-2"></i><span class="d-none d-sm-block">UPRAVIŤ ADRESU</span>
                                    </a>
                                    <button type="button" on:click={() => { deleteAddress(row.id) }} class="btn btn-slate-50">
                                        <i class="fas fa-fw fa-trash mr-sm-2 mr-md-0 mr-xl-2"></i><span class="d-none d-sm-block d-md-none d-xl-block">VYMAZAŤ ADRESU</span>
                                    </button>
                                </div>
                            </div>
                        {/each}
                    {:else}
                        <p>Tu si môžte uložiť vaše adresy. Kliknutím na <b>pridať novú adresu</b> vytvoríte adresu, ktorú budete môcť vybrať v procese objednávky a ušetríte si vyplňovanie.</p>
                    {/if}
                {:catch error}
                    <Error/>
                {/await}
            </div>
        </div>
    </div>
</section>